import styled from "styled-components";

export const StyledBodyRight = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: fit-content;
  align-items: center;
`;
